import React from "react";
import Navbar from "../../Components/Navbar/Navbar";
import AdvisorProfile from '../../Components/AdvisorProfile/AdvisorProfile';

function AdvisorProfileScreen() {

    return (
        <>
            <Navbar variant="profile" />
            <div className="container">
                <main className="profile-content">
                    <AdvisorProfile />
                </main>
            </div>
        </>
    );
}

export default AdvisorProfileScreen;
